import FlowGraphStartNode from './FlowGraphStartNode';

class FlowGraphTriggerNode extends FlowGraphStartNode {
}

FlowGraphTriggerNode.propTypes = {
	...FlowGraphStartNode.propTypes
};

FlowGraphTriggerNode.defaultProps = {
	className: 'trigger',
	icon: 'icon-GG-optional'
};

export default FlowGraphTriggerNode;
